import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';


import { AuthenticationService } from '@app/_services';

@Injectable({ providedIn: 'root' })
export class AuthGuard 
{
	constructor(
		private router: Router,
		private authenticationService: AuthenticationService
	) { }

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot)
	{
		try
		{
			const currentUser = this.authenticationService.currentUserValue;
			if (currentUser)
			{
				// authorised so return true
				return true;
			}

			// not logged in so redirect to login page with the return url
			this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
			return false;
		} catch (error)
		{
			console.log('Error(canActivate): ' + error);
		}
	}
}
